module.exports = __webpack_public_path__ + "static/media/hub1.10b08919.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/hub1.png
// module id = 1222
// module chunks = 0